// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard } from '@tabler/icons';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
    id: 'dashboard',
    title: <FormattedMessage id="Dashboard" />,
    icon: IconDashboard,
    type: 'group',
    url: ERoutes.dashboard,
    children: [
        {
            id: 'Dashboard',
            title: 'Home',
            type: 'item',
            url: ERoutes.dashboard,
            icon: IconDashboard,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
